module.exports = __webpack_public_path__ + "img/site-0-2.a1f77fd1.svg";